<template>
  <div id="all" class="animated fadeIn">
    <b-card>
        <b-card-body>
          <div v-if="!loading">
              <b-row v-if="data">
                <table class="rekap-ro table-bordered table-responsive">
                  <thead>
                    <tr>
                      <th rowspan="2" class="width-250">Customer</th>
                      <th class="width-250">RO Minggu Lalu</th>
                      <th colspan="6" class="width-550">RO TGL</th>
                    </tr>

                    <tr>
                      <th>{{data.last_week.label}}</th>
                      <template v-for="(v, index) in data.this_week.label">
                        <th :key="uniqueId(index+'A')" class="width-250">{{v}}</th>
                      </template>
                    </tr>
                  </thead>

                  <tbody>
                    <template v-for="(v, index) in data.customer">
                      <tr :key="uniqueId(index+'B')">
                        <td>
                          {{index}} &nbsp; <i class="fa fa-info" @click="showDetail(index)"></i>
                        </td>
                        <td>{{formatPrice(data.last_week.data[index])}}</td>
                        <template v-for="(v, index2) in data.this_week.label">
                          <td :key="uniqueId(index2+'C')" v-bind:class="data.this_week['color-table'][index2]">{{formatPrice(data.this_week.data[v][index])}}</td>
                        </template>
                      </tr>
                    </template>
                  </tbody>
                </table>
            </b-row>

            <template v-for="(top_data, top_index) in detail.data">
              <b-row  :key="uniqueId(top_index+'A')">
                <table class="rekap-ro table-bordered table-responsive">
                  <thead>
                    <tr>
                      <th rowspan="2" class="width-250">Customer</th>
                      <th colspan="13" class="width-550">{{description[top_index]}}</th>
                    </tr>

                    <tr>
                      <template v-for="(v, index) in detail.label">
                        <th :key="uniqueId(index+'A')" class="width-250">{{v}}</th>
                      </template>
                    </tr>
                  </thead>

                  <tbody>
                    <template v-for="(r, index) in detail.data[top_index]">
                      <tr :key="uniqueId(index+'B')">
                        <td>{{index}}</td>
                        <template v-for="(v2, index2) in r">
                          <td :key="uniqueId(index2+'C')" v-bind:class="detail['color-table'][index2]">{{formatPrice(v2)}}</td>
                        </template>
                      </tr>
                    </template>
                  </tbody>
                </table>
            </b-row>
            </template>
          </div>
          <div v-else>
            <loading></loading>
          </div>
        </b-card-body>
    </b-card>

    <b-modal
      ref="showModalRef"
      id="addModals"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">List Customer Group</h3>
      </div>
      <strong>Hitungan ini gabungan dari customer group di bawah:</strong>
      <div v-html="details" style="text-align: left;"></div>

      <div slot="modal-footer" class="float-right">
          <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
            <i class="fa fa-undo"></i> Back
          </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import * as moment from "moment";
import _ from "lodash";

export default {
  name: "dashboard-recap-ro",
  components: {
    loading
  },
  props: {},
  data: function() {
    return {
        data: [],
        detail: [],
        description: [],
        loading: true,
        customer_exp: [],
        details: null
    };
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    init: function() {
      this.loading = true;
      let employee_id = localStorage.getItem("employee_id");
      this.axios
        .get("web/recap_ro/calculation/")
        .then(response => {
          this.data = response.data;
          this.detail = response.data.detail.data;
          this.description = response.data.detail.description;
          this.customer_exp = response.data.detail.customer_exp;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });


        // this.axios
        // .get("web/recap_ro/calculation-detail/")
        // .then(response => {
        //   this.detail = response.data.data;
        // })
        // .catch(error => {})
        // .finally(() => {
        //   this.loading = false;
        // });
    },
    showDetail: function(index) {
      this.details = this.customer_exp[index].nm;
      this.$refs.showModalRef.show();
    },
     cancelAdd: function() {
      this.$refs.showModalRef.hide();
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Konsumen",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>